import {action} from '@api'
import {VipLocalStore} from '@modules'
import {IServerPDFQueryPayload, IServerRenderedPDFTemplateInstance} from '@modules/pdf'
import {DocumentLoadEvent, ScrollMode} from '@react-pdf-viewer/core'
import {AssortmentSettings, CatalogSerializableSettings, ICatalogUserSettings, StoresInstance} from '@stores'
import {computed} from 'mobx'

export class ServerPDFTemplate extends VipLocalStore implements IServerRenderedPDFTemplateInstance {
  constructor(public stores: StoresInstance, public template: string) {
    super(stores)
  }

  get esQuery() {
    const {catalog: {queryVariablesEs}} = this

    return _.pick(queryVariablesEs, 'query')
  }

  get settings(): CatalogSerializableSettings | AssortmentSettings {
    const {catalog: {settings}} = this

    return settings
  }

  get defaultPdfFilename() { return this._defaultPdfFilename}
  @computed get _defaultPdfFilename() {
    const {stores: {tab, users: {user: {name}}}} = this, timestamp = new Date()

    return tab?.displayName ?? `${name}` // (${timestamp.toLocaleString()})`
  }

  get isDisabled() { return false}

  _submitPDFJob = async (filename?: string) => {
    const {defaultPdfFilename, cloudPDF: {generatePDF}, stores: {users: {user: {id: userId}}}, esQuery, settings, template, catalog: {index}} = this

    return await generatePDF({
      index,
      template,
      userId,
      body: {...esQuery},
      settings,
      filename: filename ?? defaultPdfFilename
    })
  }

  submitPDFJob = async (filename?: string) => this._submitPDFJob(filename)

  @computed get queryPayload(): IServerPDFQueryPayload {
    const {catalog: {index, queryVariablesEs}, esQuery: body, stores: {users: {user: {id: userId}}}, template, settings} = this
    return {
      body,
      index,
      settings,
      template,
      userId
    }
  }

  get text() {
    return 'Generic PDF Template'
  }

  get catalogFeatures(): { groupBy?: boolean; viewOptions?: boolean; sortBy?: boolean; imageSources?: boolean; catalogFooter?: boolean } {
    return {}
  }

  @action onDocumentLoad = (e: DocumentLoadEvent) => {
    const {doc} = e,
      {
        cloudPDF: {
          defaultLayoutPluginInstance: {
            bookmarkPluginInstance,
            attachmentPluginInstance,
            thumbnailPluginInstance,
            toolbarPluginInstance: {scrollModePluginInstance, zoomPluginInstance}
          },
          component: {selectedPdf}
        }
      } = this

    // zoomPluginInstance.zoomTo(SpecialZoomLevel.PageFit)
    scrollModePluginInstance.switchScrollMode(selectedPdf?.entry?.pages === 1 ? ScrollMode.Vertical : ScrollMode.Wrapped)
    //thumbnailPluginInstance.
  }
}


// WEBPACK FOOTER //
// ./src/modules/pdf/serverRenderedPDF/templates/ServerPDFTemplate.ts